import { createContext } from 'react'
import { Cookies } from 'react-cookie'

const ApplyParamsContext = createContext({})
const cookies = new Cookies()

export default ApplyParamsContext

export function condenseParams(applyParams) {
  let dynamicApplyParamsHistory = cookies.get('dynamicApplyParamsHistory')

  if (typeof dynamicApplyParamsHistory !== 'object') {
    dynamicApplyParamsHistory = null
  }
  // take all params from url that's whitelisted in dynamicapplyparams
  // put them in extraapplyparams
  const { dynamicApplyParams } = applyParams
  let { extraApplyParams } = applyParams

  if (typeof window === 'undefined') return { extraApplyParams }

  const windowSearchUrl = window.location.search
  const searchParams = new URLSearchParams(windowSearchUrl)
  if (!extraApplyParams) {
    extraApplyParams = {}
  }
  const extraLowerToCapital = {} // lower case to capital map
  Object.keys(extraApplyParams).map(el => (extraLowerToCapital[el.toLowerCase()] = el))

  if (applyParams.dynamicApplyParams) {
    const dynamicLowerToCapital = {} // lower case to capital map, key: lowercase, value: proper case
    dynamicApplyParams.map(el => (dynamicLowerToCapital[el.toLowerCase()] = el))
    Array.from(searchParams).forEach(pair => {
      const [key, value] = pair
      const keyLower = key.toLowerCase()
      const keyInExtra = extraLowerToCapital[keyLower]
      const capitalKey = dynamicLowerToCapital[keyLower]
      if (capitalKey && !keyInExtra) {
        extraApplyParams[capitalKey] = value
      }
    })
  }

  if (dynamicApplyParamsHistory) {
    Object.keys(dynamicApplyParamsHistory).forEach(key => {
      const keyLower = key.toLowerCase()
      const keyInExtra = extraLowerToCapital[keyLower]
      if (!keyInExtra) {
        extraApplyParams[key] = dynamicApplyParamsHistory[key]
      }
    })
  }
  return { extraApplyParams }
}

export function paramsToURL(extraApplyParams) {
  if (!extraApplyParams) return ''
  let url = ''
  Object.entries(extraApplyParams).forEach(entry => {
    const [key, value] = entry
    url = `${url}&${key}=${value}`
  })
  return url
}
